import ImageButton from "components/General/ImageButton";
import { HIGHLIGHTS } from "utils/ToolTipConst";
import Bank from "components/Bank/Bank";
import MapTutorial from "components/Map/MapTutorial";
import YearReport from "components/Simulation/YearReport";
import { useNavigate } from "react-router-dom";
// import ConnectionStatus from "components/ConnectionStatus";
import SimulationResult from "components/Simulation/SimulationResult";
import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useWebSocket } from "WebSocketContext";
import { useGameContext } from "GameContext";

import Chat from "components/Chat/Chat";
import ChatRoom from "components/Chat/ChatRoom";

import BackButton from "components/BackButton";

import WindowComponent from "react-flexi-window";
import Map from "components/Map/Map";

import IconButton from "components/General/IconButton";

import RoleTutorial from "components/InfoTabs/RoleTutorial";
import BasicTutorial from "components/InfoTabs/BasicsTutorial";

import RoleInfo from "components/Player/RoleInfo";
import Timer from "components/Timer";

import InfoPopout from "components/Wrappers/InfoPopout";


import { actions as gameActions} from "utils/game-information-constants";

import {
  type GameState,
  createGameActionsFromProposal,
  getAggrigateCosts,
  getNextGameState,
} from "utils/game_utils";

import { WATER_LEVEL_MANAGEMENT_SCHEMES } from "utils/simulator";
import * as sim from "utils/simulator";

import ActionTutorial from "components/InfoTabs/ActionTutorial";

interface ChatHeaders {
  id: string;
  disabled: boolean;
}

interface SimResults {
  mapActions: Record<string, any>;
  muActions: Record<string, any>;
  faunaActions: Record<string, any>;
  waterRegime: number;
  gameState: GameState;
  agCost: any;
}

const MainPlay: React.FC = () => {
  const { isConnected, socket } = useWebSocket();
  const {
    playerInfo,
    currentGameState,
    roleGroups,
    timeLeft,

    isAdmin,
    hostIsPlaying,
    currentYear,
    gameId,
    proposedMoneyTransfers,
    changeInHerdEvent,

    roleGroupDataHistory,
    gameEnded,

    reservationMuActions,
  } = useGameContext();

  const navigate = useNavigate();

  useEffect(() => {
    if (!gameId || !isConnected) {
      navigate("/play");
    }
  }, [gameId, isConnected])

  function onMessage(event: MessageEvent<string>) {
    if (event.data) {
      const message = JSON.parse(event.data);
      if (message.kind === "GoToVoteRoom") {
        navigate("/play/main/vote");
      }
    }
  }

  useEffect(() => {
    if (!socket) return;
    socket.addEventListener("message", onMessage);

    return () => {
      if (socket) {
        socket.removeEventListener("message", onMessage);
      }
    };
  }, [socket]);

  const roleGroup = roleGroups[`${playerInfo?.estate}-${playerInfo?.role}`];
  const simData = currentGameState?.simData;
  // #region state variables
  const [showChat, setShowChat] = useState(false);
  const [showBank, setShowBank] = useState(false);
  const [showRoleInfo, setShowRoleInfo] = useState(false);
  const [showReport, setShowReport] = useState(false);
  const [chatWindows, setChatWindows] = useState<ChatHeaders[]>([]);
  const [simulationResults, setSimulationResults] = useState<Array<SimResults>>(
    []
  );
  // #endregion

  // Map controls
  const [recenterScreen, setRecenterScreen] = useState(false);

  // #region tutorial windows state variables
  // here we have a variable to handle the visibility of our tutorial windows. This way we only have to pass one state variable to the map, which has the components to show it.
  const [tutorialWindows, setTutorialWindows] = useState(
    Object.fromEntries(
      Object.keys(gameActions).map((key) => [
        key,
        { open: false, firstOpened: false },
      ])
    )
  );

  const [showMapTutorial, setShowMapTutorial] = useState(false);

  // setter and getter function to abstract the above
  const toggleTutorialWindow = (key: string) => {
    setTutorialWindows(prev => ({
      ...prev,
      [key]: {
        ...prev[key],
        open: !prev[key].open,
        firstOpened: prev[key].firstOpened || !prev[key].open, // mark firstOpened true the first time it opens
      },
    }));
  };
  const getTutorialWindowState = (key: string) => {
    return tutorialWindows[key] || { open: false, firstOpened: false };
  };


  const [basicTutorialVisible, setBasicTutorialVisible] = useState(false);
  const [roleTutorialVisible, setRoleTutorialVisible] = useState(false);
  const [showWMRGraph, setShowWMRGraph] = useState(false);
  // #endregion
  


  const addChatWindow = (inputId: string) => {
    setChatWindows((prev) => {
      const existing = prev.find((window) => window.id === inputId);

      if (existing) {
        // If it exists and is disabled, enable it
        if (existing.disabled) {
          return prev.map((window) =>
            window.id === inputId ? { ...window, disabled: false } : window
          );
        }
        // If it exists and is already enabled, do nothing
        return prev;
      }

      // If it doesn't exist, add new
      const newWindow: ChatHeaders = {
        id: inputId,
        disabled: false,
      };
      return [...prev, newWindow];
    });
  };

  const disableChatWindow = (inputId: string) => {
    setChatWindows((prev) =>
      prev.map((window) =>
        window.id === inputId ? { ...window, disabled: true } : window
      )
    );
  };

  function renderRoleIcon() {
    switch (playerInfo?.role) {
      case "Reed Harvester":
        return "/ActionIcons/Reed-Harvester.png";
      case "Stockbreeder":
        return "/ActionIcons/Stockbreeder.png";
      case "Conservationist":
        return "/ActionIcons/Conservationist-NGO.png";
      case "Hunter":
        return "/ActionIcons/Hunter.png";
    }
    return "";
  }

  function addSimulationResult(
    waterRegime: number,
    gameState: GameState,
    proposedMapActions: Record<string, any>,
    proposedMuActions: Record<string, any>,
    proposedFaunaActions: Record<string, any>
  ) {
    if (waterRegime <= 0) {
      return;
    }

    const mapActionArray = Object.keys(proposedMapActions).map(function (key) {
      return proposedMapActions[key];
    });

    const muActionArray = Object.keys(proposedMuActions).map(function (key) {
      return proposedMuActions[key];
    });

    const faunaActionArray = Object.keys(proposedFaunaActions).map(function (
      key
    ) {
      return proposedFaunaActions[key];
    });

    const reservationActionArray = Object.keys(reservationMuActions).map(function (key) {
      return reservationMuActions[key]
    })

    const proposal = {
      moneyTransfers: proposedMoneyTransfers,
      faunaActions: faunaActionArray,
      mapActions: mapActionArray,
      muActions: muActionArray,

      changeInHerdEvents: [changeInHerdEvent],
      reservationMuActions: reservationActionArray, // Array.from(proposedReservationMuActions.values()),
    }

    const newGameActions = createGameActionsFromProposal(proposal, waterRegime - 1); // Subtract 1 for index

    const newGameState = getNextGameState(gameState, newGameActions);

    const flv = sim.getFloraVariability(currentYear - 1); // year is 1 indexed so we subtract
    const fuv = sim.getFloraVariability(currentYear - 1);

    const agcost = getAggrigateCosts(
      proposal,
      newGameState,
      WATER_LEVEL_MANAGEMENT_SCHEMES[waterRegime - 1],
      roleGroup,
      playerInfo?.estate,
      playerInfo?.role,
      fuv,
      flv
    );

    setSimulationResults((prev) => [
      ...prev,
      {
        faunaActions: proposedFaunaActions,
        mapActions: proposedMapActions,
        muActions: proposedMuActions,
        waterRegime: waterRegime,
        gameState: newGameState,
        agCost: agcost,
      },
    ]);

    // console.log("COSTS FOR HYPOTHETICAL : ", agcost);
    /*
    simGameState = newGameState;
    //common.updateGameScore(simGameState, role);

    updateRoleDataWithActions();
    */
  }

  useEffect(() => {
    const handleBeforeUnload = (event: BeforeUnloadEvent) => {
      const message = "Are you sure you want to leave? Data may be lost";
      if (!window.confirm(message)) {
        // User pressed "Cancel" → block unload
        event.preventDefault();
        event.returnValue = "";
      }
      // If user pressed "OK", allow unload
    };

    window.addEventListener("beforeunload", handleBeforeUnload);
    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, []);

  useEffect(() => {
    setSimulationResults([]);
    setChatWindows([]);
    setShowReport(true);

    if (currentYear === 1) {
      setBasicTutorialVisible(true)
      setRoleTutorialVisible(true)
      setShowMapTutorial(true);
    }
  }, [currentYear]);

  return (
    <div className="flex h-[100vh] w-[100vw]">
      <div className="absolute left-0 top-0 flex flex-col border-r-2 border-b-2 border-black p-2 z-[999] bg-[#BCB7A8]">
        <h2>{`Year:${currentYear}`}</h2>
        <div className="flex flex-row items-center gap-2">
          <h1 className="text-sm capitalize">
            {playerInfo?.playerName} {playerInfo?.role}
          </h1>
          <h1 className="border-black border rounded-full px-2 py-1 text-xs capitalize">
            {playerInfo?.estate}
          </h1>
        </div>
          <div className=" absolute left-0 top-[100%] border-r-2 border-y-2 border-black p-2 bg-[#BCB7A8] flex flex-row items-center gap-2">
            <button className="w-4 h-4 text-xl flex-col items-center justify-center"
              onClick={() => { setRecenterScreen((prev) => !prev) }}
            >
              <div className="pointer-events-none absolute top-0">˹˺</div>
              <div className="pointer-events-none absolute top-0">˻˼</div>
            </button>

            <button onClick={() => {
              setShowMapTutorial(true)
            }}>
              Map Navigation
            </button>
          </div>
        </div>




      <div className="absolute text-xl right-0 top-0 flex flex-row z-[999] border-b-2 border-l-2 border-black bg-[#BCB7A8] p-2 items-center">
        {isAdmin && (
          <IconButton
            icon={"HOST CONTROLS"}
            onClick={() => navigate("/play/main/host")}
          />
        )}
        <ImageButton
          imgSrc="/Images/WMRGraph.jpg"
          onClick={() => {
            setShowWMRGraph((prev => !prev))
          }}
        >
          <InfoPopout
            maxWidth={400}
            popupContent={
              <div>
                <p>Shows the Water Management Regime Graph.</p>
              </div>
            }/>

        </ImageButton>
        <ImageButton
          imgSrc="/ActionIcons/Help.png"
          onClick={() => {
            setBasicTutorialVisible(true)
            setRoleTutorialVisible(true)
          }}
        >
          <InfoPopout
            maxWidth={400}
            popupContent={
              <div>
                <p>Basic Tutorial:</p>
                <p>Shows the basic tutorial.</p>
              </div>
            }
          />
        </ImageButton>

        <ImageButton
          imgSrc="/ActionIcons/Chat.png"
          onClick={() => setShowChat((prev) => !prev)}
        >
          <InfoPopout
            maxWidth={400}
            popupContent={
              <div>
                <p>Messages:</p>
                <p>Send and receive messages with other players.</p>
              </div>
            }
          />
        </ImageButton>
        <ImageButton
          imgSrc="/ActionIcons/bank.png"
          onClick={() => setShowBank((prev) => !prev)}
        >
          <InfoPopout
            maxWidth={400}
            popupContent={
              <div>
                <p>Bank:</p>
                <p>View capital, and send it to other players.</p>
              </div>
            }
          />
        </ImageButton>

        {currentYear > 1 && (
          <ImageButton
            imgSrc="/ActionIcons/End-Year-Report.png"
            onClick={() => setShowReport((prev) => !prev)}
          >
            <InfoPopout
              maxWidth={400}
              popupContent={
                <div>
                  <p>View Report</p>
                </div>
              }
            />
          </ImageButton>
        )}

        <ImageButton
          imgSrc={renderRoleIcon()}
          onClick={() => setShowRoleInfo((prev) => !prev)}
        >
          <InfoPopout
            maxWidth={400}
            popupContent={
              <div>
                <p>Role Info</p>
              </div>
            }
          />
        </ImageButton>
      </div>

      <Map
        addSimulationResult={addSimulationResult}
        showFullMap={playerInfo?.role === "Conservationist"}
        tutorialWindows={tutorialWindows}
        toggleTutorialWindow={toggleTutorialWindow}
        getTutorialWindowState={getTutorialWindowState}
        recenterScreen={ recenterScreen }
        showAnimals={playerInfo?.role === "Conservationist"}
        showDucksOnly={playerInfo?.role === "Hunter"}
      />

      <div
        style={{
          opacity: showMapTutorial ? 1 : 0, // lower opacity if disabled
          pointerEvents: !showMapTutorial ? "none" : "auto", // ignore mouse events if disabled
          position: "absolute",
        }}
      >
        <WindowComponent
          w={300}
          h={355}
          minW={100}
          minH={100}
          x={0}
          y={100}
          // windowColor={"black"} //blue-500/20"}
          boundary={true}
          className="h-full w-full border-2 border-black bg-[#BCB7A8] p-2"
          // zIndex={}
        >
          <MapTutorial onClose={() => setShowMapTutorial(false)} />
        </WindowComponent>
      </div>
      <div
        style={{
          opacity: showWMRGraph ? 1 : 0, // lower opacity if disabled
          pointerEvents: !showWMRGraph ? "none" : "auto", // ignore mouse events if disabled
          position: "absolute",
        }}
      >
        <WindowComponent
          w={300}
          h={300}
          minW={100}
          minH={100}
          x={0}
          y={200}
          // windowColor={"black"} //blue-500/20"}
          boundary={true}
          className="h-full w-full border-2 border-black bg-[#BCB7A8] p-2"
          // zIndex={}
        >
          <button
            className="absolute right-0 top-0 p-2"
            onClick={() => setShowWMRGraph((prev) => !prev)}
          >
            x
          </button>
          <img src={"/Images/WLregime.png"}></img>
        </WindowComponent>
      </div>

      <div
        style={{
          opacity: showBank ? 1 : 0, // lower opacity if disabled
          pointerEvents: !showBank ? "none" : "auto", // ignore mouse events if disabled
          position: "absolute",
        }}
      >
        <WindowComponent
          w={300}
          h={255}
          minW={100}
          minH={100}
          x={0}
          y={100}
          // windowColor={"black"} //blue-500/20"}
          boundary={true}
          className="h-full w-full border-2 border-black bg-[#a19881] p-2"
          // zIndex={}
        >
          <Bank onClose={() => setShowBank(false)} />
        </WindowComponent>
      </div>

      <div
        style={{
          opacity: showRoleInfo ? 1 : 0, // lower opacity if disabled
          pointerEvents: !showRoleInfo ? "none" : "auto", // ignore mouse events if disabled
          position: "absolute",
        }}
      >
        <WindowComponent
          w={300}
          h={500}
          minW={100}
          minH={100}
          x={0}
          y={310}
          boundary={true}
          className="h-full w-full border-2 border-black bg-[#a19881]"
        >
          <RoleInfo
            onInfoClick={() => setShowRoleInfo(false)}
            playerInfo={playerInfo}
          />
        </WindowComponent>
      </div>

      <div
        style={{
          opacity: showChat ? 1 : 0, // lower opacity if disabled
          pointerEvents: !showChat ? "none" : "auto", // ignore mouse events if disabled
          position: "absolute",
        }}
      >
        <WindowComponent
          w={400}
          h={400}
          minW={100}
          minH={100}
          x={5000}
          y={5000}
          // windowColor={"black"} //blue-500/20"}
          boundary={true}
        >
          <Chat
            onRoomClick={addChatWindow}
            onClose={() => setShowChat(false)}
          />
        </WindowComponent>
      </div>
      <div
        style={{
          opacity: basicTutorialVisible ? 1 : 0, // lower opacity if disabled
          pointerEvents: !basicTutorialVisible ? "none" : "auto", // ignore mouse events if disabled
          position: "absolute",
        }}
      >
        <WindowComponent
          w={500}
          h={600}
          minW={100}
          minH={100}
          x={200}
          y={150}
          // windowColor={"black"} //blue-500/20"}
          boundary={true}
        >
          <div className="flex flex-col h-full w-full border-2 border-black bg-[#BCB7A8] p-2 overflow-auto">
            <button
              className="absolute right-0 top-0 p-2"
              onClick={() => setBasicTutorialVisible((prev) => !prev)}
            >
              x
            </button>
            <BasicTutorial />
          </div>
        </WindowComponent>
      </div>

      <div
        style={{
          opacity: roleTutorialVisible ? 1 : 0, // lower opacity if disabled
          pointerEvents: !roleTutorialVisible ? "none" : "auto", // ignore mouse events if disabled
          position: "absolute",
        }}
      >
        <WindowComponent
          w={500}
          h={600}
          minW={75}
          minH={75}
          x={800}
          y={150}
          // windowColor={"black"} //blue-500/20"}
          boundary={true}
        >
          <div className="flex flex-col h-full w-full border-2 border-black bg-[#BCB7A8] p-2 overflow-auto">
            <button
              className="absolute right-0 top-0 p-2"
              onClick={() => setRoleTutorialVisible((prev) => !prev)}
            >
              x
            </button>
            <RoleTutorial role={
              playerInfo.role === "Hunter"
                ? `${playerInfo.estate} ${playerInfo.role}`
                : playerInfo.role
            } />
          </div>
        </WindowComponent>
      </div>

      <WindowComponent
        w={220}
        h={75}
        minW={75}
        minH={75}
        x={5000}
        y={100}
        // windowColor={"black"} //blue-500/20"}
        boundary={true}
      >
        <Timer time={timeLeft} />
      </WindowComponent>

      {Object.entries(tutorialWindows).map(([key, state], index) => (
        <div
          key={key}
          style={{
            opacity: state.open ? 1 : 0,
            pointerEvents: state.open ? "auto" : "none",
            position: "absolute",
          }}
        >
          <WindowComponent
            w={500}
            h={600}
            minW={100}
            minH={100}
            x={100 + index * 8}
            y={100 + index * 8}
            boundary={true}
          >
            <div className="flex flex-col h-full w-full border-2 border-black bg-[#BCB7A8] p-2 overflow-auto">
              <button
                className="absolute right-0 top-0 p-2"
                onClick={() => toggleTutorialWindow(key)}
              >
                x
              </button>
              <ActionTutorial action={key} />
            </div>
          </WindowComponent>
        </div>
      ))}

      {simulationResults.map((result, i) => (
        <WindowComponent
          key={i}
          w={playerInfo.role=="Conservationist" ? 1000 : 500}
          h={500}
          minW={100}
          minH={100}
          x={500 + i * 5}
          y={200 + i * 5}
          // windowColor={"black"} //blue-500/20"}
          boundary={true}
        >
          <SimulationResult
            mapActions={result.mapActions}
            muActions={result.muActions}
            faunaActions={result.faunaActions}
            agCost={result.agCost}
            simResults={result.gameState}
            waterRegime={result.waterRegime}
            closeWindow={() => {
              setSimulationResults((prev) => {
                const n = [...prev];
                n.splice(i, 1);
                return n;
              });
            }}
          />
        </WindowComponent>
      ))}

      {currentYear > 1 && (
        <div
          style={{
            opacity: showReport ? 1 : 0, // lower opacity if disabled
            pointerEvents: !showReport ? "none" : "auto", // ignore mouse events if disabled
            position: "absolute",
          }}
        >
          <WindowComponent
            w={500}
            h={600}
            minW={100}
            minH={100}
            x={100}
            y={100}
            boundary={true}
          >
            <div className="flex flex-col h-full w-full border-2 border-black bg-[#BCB7A8] p-2 overflow-auto">
              <button
                className="absolute right-0 top-0 p-2"
                onClick={() => setShowReport(false)}
              >
                x
              </button>
              <YearReport showAllHistory={true}/>
            </div>
          </WindowComponent>
        </div>
      )}

      {chatWindows.map((chat: ChatHeaders, index: number) => (
        <div
          style={{
            opacity: chat.disabled ? 0 : 1, // lower opacity if disabled
            pointerEvents: chat.disabled ? "none" : "auto", // ignore mouse events if disabled
            position: "absolute",
          }}
        >
          <WindowComponent
            key={chat.id}
            w={300}
            h={300}
            minW={100}
            minH={100}
            x={500 + index * 5}
            y={500 + index * 5}
            // windowColor={"black"} //blue-500/20"}
            boundary={true}
          >
            <ChatRoom
              roomId={chat.id}
              onBackClick={() => disableChatWindow(chat.id)}
            />
          </WindowComponent>
        </div>
      ))}
    </div>
  );
};

export default MainPlay;
